import React from "react";
import {
  Container,
  Paper,
  Typography,
  Stack,
  Button,
  TextField,
  InputLabel,
  Box,
  Stepper,
  Step,
  StepLabel,
  Autocomplete,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import { companyTypes } from "./Constants";
import { workEnvironments } from "./Constants";
import { roleOpenOptions } from "./Constants";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CompanyCultureFit = ({ form, setForm, onNext, onBack }) => {
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAutocompleteChange = (name, values) => {
    // if (values.length <= 2) {
    setForm((prev) => ({ ...prev, [name]: values }));
    // }
  };

  const isValid =
    form.typeOfCompany?.length > 0 &&
    form.workEnvironment?.length > 0 &&
    form.whyJoinTeam &&
    form.whyRoleOpen;

  return (
    <Container maxWidth="lg" sx={{ mt: 6 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/corporate/job-postings")}
        sx={{ mb: 2 }}
      >
        Back to Job Postings
      </Button>
      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <Stepper activeStep={2} alternativeLabel sx={{ mb: 4 }}>
          <Step key={0}>
            <StepLabel>Create a role</StepLabel>
          </Step>
          <Step key={1}>
            <StepLabel>Set skills</StepLabel>
          </Step>
          <Step>
            <StepLabel>Company type & culture Fit</StepLabel>
          </Step>
          <Step>
            <StepLabel>Define interview process</StepLabel>
          </Step>
          <Step>
            <StepLabel>Review & Publish</StepLabel>
          </Step>
        </Stepper>

        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Company Type & Culture Fit
        </Typography>

        {/* Type of Company */}
        <InputLabel sx={{ mb: 1 }}>Type of Company *</InputLabel>
        <Autocomplete
          multiple
          limitTags={2}
          options={companyTypes}
          getOptionLabel={(option) => option.label}
          value={
            companyTypes.filter((opt) =>
              form.typeOfCompany?.includes(opt.value)
            ) || []
          }
          onChange={(e, newValue) =>
            handleAutocompleteChange(
              "typeOfCompany",
              newValue.map((v) => v.value)
            )
          }
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option.label}
                {...getTagProps({ index })}
                key={option.value}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select company type"
              fullWidth
              sx={{ mb: 3 }}
            />
          )}
        />

        {/* Work Environment */}
        <InputLabel sx={{ mb: 1 }}>Work Environment / Culture Fit *</InputLabel>
        <Autocomplete
          multiple
          limitTags={2}
          options={workEnvironments}
          getOptionLabel={(option) => option.label}
          value={
            workEnvironments.filter((opt) =>
              form.workEnvironment?.includes(opt.value)
            ) || []
          }
          onChange={(e, newValue) =>
            handleAutocompleteChange(
              "workEnvironment",
              newValue.map((v) => v.value)
            )
          }
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option.label}
                {...getTagProps({ index })}
                key={option.value}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select work environment"
              fullWidth
              sx={{ mb: 3 }}
            />
          )}
        />

        {/* Why Role Open */}
        <InputLabel id="why-role-open-label">
          Why is the role open? *
        </InputLabel>
        <Select
          labelId="why-role-open-label"
          name="whyRoleOpen"
          value={form.whyRoleOpen || ""}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 3 }}
          displayEmpty
        >
          <MenuItem value="">
            <em>Choose reason</em>
          </MenuItem>
          {roleOpenOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>

        {/* Why Join Your Team */}
        <TextField
          label="Why join your team *"
          name="whyJoinTeam"
          value={form.whyJoinTeam || ""}
          onChange={handleChange}
          fullWidth
          multiline
          minRows={6}
          sx={{ mb: 3 }}
        />

        {/* Navigation Buttons */}
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" color="secondary" onClick={onBack}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!isValid}
            onClick={onNext}
          >
            Next
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default CompanyCultureFit;
